import React from "react";
import { FORMAT_NUMBER } from "../../../common/utils";

const CompanyChartKey = props => {
  const { chartData } = props;
  return (
    <div className="event-page-company-chart-section">
      <div className="event-page-company-chart-section-title">Key stats</div>
      <div className="event-page-company-chart-section-row">
        {chartData?.overview?.highlights?.MarketCapitalization ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Market capitalization
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(
                chartData?.overview?.highlights?.MarketCapitalization,
                chartData?.stock?.currencySymbol
              )}
            </div>
          </div>
        ) : null}

        {chartData?.overview?.highlights?.EBITDA ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              EBITDA
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(
                chartData?.overview?.highlights?.EBITDA,
                chartData?.stock?.currencySymbol
              )}
            </div>
          </div>
        ) : null}

        {chartData?.overview?.highlights?.PERatio ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              P/E Ratio
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(chartData?.overview?.highlights?.PERatio)}
            </div>
          </div>
        ) : null}

        {chartData?.overview?.highlights?.PEGRatio ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              PEG Ratio
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(
                chartData?.overview?.highlights?.PEGRatio,
                chartData?.stock?.currencySymbol
              )}
            </div>
          </div>
        ) : null}

        {chartData?.overview?.highlights?.WallStreetTargetPrice ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Wall Street Target Price
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(
                chartData?.overview?.highlights?.WallStreetTargetPrice,
                chartData?.stock?.currencySymbol
              )}
            </div>
          </div>
        ) : null}
        {chartData?.overview?.highlights?.BookValue ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Book Value
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(
                chartData?.overview?.highlights?.BookValue,
                chartData?.stock?.currencySymbol
              )}
            </div>
          </div>
        ) : null}

        {chartData?.overview?.highlights?.DividendShare ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Dividend Share
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(
                chartData?.overview?.highlights?.DividendShare,
                chartData?.stock?.currencySymbol
              )}
            </div>
          </div>
        ) : null}

        {chartData?.overview?.highlights?.DividendYield ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Dividend Yield
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(chartData?.overview?.highlights?.DividendYield)}%
            </div>
          </div>
        ) : null}

        {chartData?.overview?.highlights?.EarningsShare ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Earnings per Share
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(
                chartData?.overview?.highlights?.EarningsShare,
                chartData?.stock?.currencySymbol
              )}
            </div>
          </div>
        ) : null}

        {chartData?.overview?.highlights?.EPSEstimateCurrentYear ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              EPS Estimate (Current Year)
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(
                chartData?.overview?.highlights?.EPSEstimateCurrentYear,
                chartData?.stock?.currencySymbol
              )}
            </div>
          </div>
        ) : null}

        {chartData?.overview?.highlights?.EPSEstimateNextYear ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              EPS Estimate (Next Year)
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(
                chartData?.overview?.highlights?.EPSEstimateNextYear,
                chartData?.stock?.currencySymbol
              )}
            </div>
          </div>
        ) : null}

        {chartData?.overview?.highlights?.EPSEstimateNextQuarter ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              EPS Estimate (Next Quarter)
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(
                chartData?.overview?.highlights?.EPSEstimateNextQuarter,
                chartData?.stock?.currencySymbol
              )}
            </div>
          </div>
        ) : null}
        {chartData?.overview?.highlights?.EPSEstimateCurrentQuarter ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              EPS Estimate (Current Quarter)
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(
                chartData?.overview?.highlights?.EPSEstimateCurrentQuarter,
                chartData?.stock?.currencySymbol
              )}
            </div>
          </div>
        ) : null}
        {chartData?.overview?.highlights?.MostRecentQuarter ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Most Recent Quarter
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {chartData?.overview?.highlights?.MostRecentQuarter}
            </div>
          </div>
        ) : null}
        {chartData?.overview?.highlights?.ProfitMargin ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Profit Margin
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {chartData?.overview?.highlights?.ProfitMargin}%
            </div>
          </div>
        ) : null}
        {chartData?.overview?.highlights?.OperatingMarginTTM ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Operating Margin (TTM)
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {chartData?.overview?.highlights?.OperatingMarginTTM}%
            </div>
          </div>
        ) : null}
        {chartData?.overview?.highlights?.ReturnOnAssetsTTM ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Return on Assets (TTM)
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {chartData?.overview?.highlights?.ReturnOnAssetsTTM}%
            </div>
          </div>
        ) : null}
        {chartData?.overview?.highlights?.ReturnOnEquityTTM ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Return on Equity (TTM)
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {chartData?.overview?.highlights?.ReturnOnEquityTTM}%
            </div>
          </div>
        ) : null}
        {chartData?.overview?.highlights?.RevenueTTM ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Revenue (TTM)
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(
                chartData?.overview?.highlights?.RevenueTTM,
                chartData?.stock?.currencySymbol
              )}
            </div>
          </div>
        ) : null}
        {chartData?.overview?.highlights?.RevenuePerShareTTM ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Revenue per Share (TTM)
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(
                chartData?.overview?.highlights?.RevenuePerShareTTM,
                chartData?.stock?.currencySymbol
              )}
            </div>
          </div>
        ) : null}
        {chartData?.overview?.highlights?.QuarterlyRevenueGrowthYOY ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Quarterly Revenue Growth (YOY)
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {chartData?.overview?.highlights?.QuarterlyRevenueGrowthYOY}%
            </div>
          </div>
        ) : null}
        {chartData?.overview?.highlights?.GrossProfitTTM ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Gross Profit (TTM)
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(
                chartData?.overview?.highlights?.GrossProfitTTM,
                chartData?.stock?.currencySymbol
              )}
            </div>
          </div>
        ) : null}
        {chartData?.overview?.highlights?.DilutedEpsTTM ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Diluted EPS (TTM)
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(
                chartData?.overview?.highlights?.DilutedEpsTTM,
                chartData?.stock?.currencySymbol
              )}
            </div>
          </div>
        ) : null}
        {chartData?.overview?.highlights?.QuarterlyEarningsGrowthYOY ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Quarterly Earnings Growth
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {chartData?.overview?.highlights?.QuarterlyEarningsGrowthYOY}%
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CompanyChartKey;
